import { darken, alpha, makeStyles, Theme, Typography } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ArrowBackIos';
import { useAppSelector } from 'hooks/redux';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles<Theme, { color: string }>((theme) => ({
  container: {
    position: 'fixed',
    alignItems: 'center',
    background: alpha(theme.palette.neutrals.black, 0.5),
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(2, 3),
    height: 40,
    zIndex: 10,
    width: '100%',
    '& > div:first-child': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    '& p': {
      cursor: 'pointer',
      color: (props) => props.color ?? theme.palette.common.white,
      '&:last-child': {
        color: (props) => (props.color ? darken(props.color, 0.2) : theme.palette.primary.light),
        fontWeight: 'bold',
      },
    },
    '& svg': {
      cursor: 'pointer',
      fontWeight: 600,
      width: 20,
      height: 20,
      color: (props) => props.color ?? theme.palette.primary.main,
      marginRight: theme.spacing(8),
    },
  },
  slash: {
    padding: theme.spacing(0, 2),
  },
  itemBreadCrumb: {
    cursor: 'pointer',
  },
}));

const BreadCrumbComponent = () => {
  const history = useHistory();
  const customizations = useAppSelector((store) => store.customizations);
  const classes = useStyles({ color: customizations?.header_link_color });

  const goTo = (to: string) => () => {
    history.push(to);
  };
  const { pathname } = history.location;
  const splitedPathname = pathname.split('/');
  const mapper = ['/curso', '/aula', '/certificados', '/perfil', '/ajuda', '/notificacoes'];
  if (!mapper.some((path) => pathname.startsWith(path))) return null;

  const isLessonPage = pathname.startsWith('/curso') && pathname.includes('/aula/');

  return (
    <div className={classes.container}>
      <div onClick={goTo('/vitrine')}>
        <ChevronLeft />
      </div>
      <Typography style={{ cursor: 'default' }} variant='body2' onClick={goTo('/vitrine')}>
        Início
      </Typography>
      <Typography style={{ cursor: 'default' }} variant='body2' className={classes.slash}>
        /
      </Typography>
      <Typography style={{ cursor: 'default' }} variant='body2'>
        {pathname.startsWith('/curso') && (
          <div className={classes.itemBreadCrumb} onClick={goTo(`/${splitedPathname[1]}/${splitedPathname[2]}`)}>
            Curso
          </div>
        )}
        {pathname.startsWith('/certificado') && 'Meus Certificados'}
        {pathname.startsWith('/perfil') && 'Meu Perfil'}
        {pathname.startsWith('/ajuda') && 'Ajuda'}
        {pathname.startsWith('/aulas/salvas') && 'Aulas salvas'}
        {pathname.startsWith('/notificacoes') && 'Notificações'}
      </Typography>

      {isLessonPage && (
        <>
          <Typography style={{ cursor: 'default' }} variant='body2' className={classes.slash}>
            /
          </Typography>
          <Typography style={{ cursor: 'default' }} variant='body2'>
            Aula
          </Typography>
        </>
      )}
    </div>
  );
};

export default BreadCrumbComponent;
